import script from "./WizardScalingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardScalingPage.vue?vue&type=script&setup=true&lang=js"

import "./WizardScalingPage.vue?vue&type=style&index=0&id=adac086e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adac086e"]])

export default __exports__